import React from 'react';
import styles from './Mbn.module.scss';
import { mbnColorPicker } from '../../../../../utils/helpers';
import StatisticsIcon from '../../../Icons/StatisticsIcon/StatisticsIcon';

const Mbn = ({ mbn, statisticsUrl, isESports }) => {
    const mbnColor = mbnColorPicker(mbn);

    return (
        <td className={styles.mbnWrapper} align='right'>
            <div className={styles.mbn} style={{ backgroundColor: mbnColor }}>
                {mbn}
            </div>
            {!isESports && (
                <div className={`${styles.statistics} m-t-1`}>
                    <a href={statisticsUrl} target={'_blank'} onClick={e => e.stopPropagation()}>
                        <StatisticsIcon />
                    </a>
                </div>
            )}
        </td>
    );
};

export default Mbn;
